import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LessonLine } from './BillingEntryDetails';
import { money } from './clientPortalSelectors';

export default function BillingEstimate({ estimate }) {
  const { t: tr, i18n } = useTranslation();
  if (!estimate) return null;
  return (
    <section className="client-portal__card portal-billing__estimate">
      <h2>{tr('client:billing.estimate.title')}</h2>
      <p className="text-muted">{tr('client:billing.estimate.explanation')}</p>
      {estimate.status !== 'ready' ? <p role="status">{tr('client:billing.estimate.unavailable')}</p> : (
        <>
          {!estimate.months.length && <p>{tr('client:billing.estimate.empty')}</p>}
          {estimate.months.map(period => (
            <details key={period.month} className="portal-billing__details" open>
              <summary>{period.month.split('-').reverse().join('.')} · {tr('client:billing.estimate.amount')}: {' '}
                {period.totalCents === null ? tr('client:billing.estimate.incomplete') : money(period.totalCents / 100, i18n.language)}
              </summary>
              <div className="portal-billing__detail-content">
                {period.totalCents === null && <p role="status">{tr('client:billing.estimate.missingRate')}</p>}
                {period.items.map(item => (
                  <div key={item.key}>
                    <LessonLine item={item} />
                    {item.reason && <p className="text-muted">{tr(`client:billing.reasons.${item.reason}`)}</p>}
                  </div>
                ))}
              </div>
            </details>
          ))}
        </>
      )}
    </section>
  );
}
BillingEstimate.propTypes = { estimate: PropTypes.object };
BillingEstimate.defaultProps = { estimate: null };
